import { images } from "../../constants";

export const experience = [
  {
    year: 2022,
    works: [
      {
        name: "Frontend Developer",
        company: "Ikon Soft",
        desc1: "Responsible for creating visually appealing layouts and intuitive user interfaces for data-driven web applications using HTML, CSS, JavaScript, Vue, Bootstrap, and Element UI.",
        desc2: "Design and develop robust front-end solutions that meet clients' needs.",
        desc3: "Work with data using Chart.js to represent data in a visually compelling manner, making it easier for users to understand and derive insights.",
      },
    ],
  },
];

export const programs = [
  {
    name: "React",
    icon: images.react,
    bgColor: "#edf2f8",
  },
  {
    name: "Redux",
    icon: images.redux,
    bgColor: "#edf2f8",
  },
  {
    name: "Vue",
    icon: images.vue,
    bgColor: "#edf2f8",
  },
  {
    name: "Vuex",
    icon: images.vuex,
    bgColor: "#edf2f8",
  },
  {
    name: "Sass",
    icon: images.sass,
    bgColor: "#edf2f8",
  },
  {
    name: "GraphQL",
    icon: images.graphql,
    bgColor: "#edf2f8",
  },
  {
    name: "Quasar",
    icon: images.quasar,
    bgColor: "#edf2f8",
  },
  {
    name: "Element UI",
    icon: images.elementUI,
    bgColor: "#edf2f8",
  },
  {
    name: "Git",
    icon: images.git,
    bgColor: "#edf2f8",
  },
  {
    name: "Javascript",
    icon: images.javascript,
    bgColor: "#edf2f8",
  },
  {
    name: "Html",
    icon: images.html,
    bgColor: "#edf2f8",
  },
  {
    name: "Css",
    icon: images.css,
    bgColor: "#edf2f8",
  },
];
